const getBordersColors = () => {
  return {
    borderColor: {
      default: 'gray.300',
      _dark: 'gray.600',
    },
    borderColorPrimary: {
      default: 'primary.400',
      _dark: 'primary.500',
    },
  }
}

export default getBordersColors()
